import { handleErrorException, loading, success } from 'State/actions';
import { TitleEnum } from 'Common/Constants/Enumeration/CommonEnum';

import * as types from './types';

export const getBidGroupForCurrentSite = bidEnum => {
  return async (dispatch, getState, MPWWebApi) => {
    dispatch(loading(types.FETCH_BID_GROUP_DATA_LOADING, true));

    try {
      const response = await MPWWebApi.getGeneric(
        `InvGroup/GetBidsGroup/${bidEnum}`
      );
      dispatch(success(types.SET_BID_GROUP_DATA, response));
    } catch (ex) {
      const defaultError = {
        Title: TitleEnum.Error,
        Message:
          'An error occurred while fetching bid groups. Please try again.',
      };
      dispatch(
        handleErrorException(
          ex,
          types.FETCH_BID_GROUP_DATA_LOADING_ERROR,
          defaultError
        )
      );
    } finally {
      dispatch(loading(types.FETCH_BID_GROUP_DATA_LOADING, false));
    }
  };
};

export const getItemGroupForCurrentSite = () => {
  return async (dispatch, getState, MPWWebApi) => {
    dispatch(loading(types.FETCH_ITEM_GROUP_DATA_LOADING, true));

    try {
      const response = await MPWWebApi.getGeneric('InvGroup/GetItemsGroup');
      dispatch(success(types.SET_ITEM_GROUP_DATA, response));
    } catch (ex) {
      const defaultError = {
        Title: TitleEnum.Error,
        Message:
          'An error occurred while fetching item groups. Please try again.',
      };
      dispatch(
        handleErrorException(
          ex,
          types.FETCH_ITEM_GROUP_DATA_LOADING_ERROR,
          defaultError
        )
      );
    } finally {
      dispatch(loading(types.FETCH_ITEM_GROUP_DATA_LOADING, false));
    }
  };
};

export const getAcctCategoryForCurrentSite = () => {
  return async (dispatch, getState, MPWWebApi) => {
    dispatch(loading(types.FETCH_ACCT_CATEGORY_DATA_LOADING, true));

    try {
      const response = await MPWWebApi.getGeneric(
        'InvGroup/GetAccountCategory/0'
      );
      dispatch(success(types.SET_ACCT_CATEGORY_DATA, response));
    } catch (ex) {
      const defaultError = {
        Title: TitleEnum.Error,
        Message:
          'An error occurred while fetching account categories. Please try again.',
      };
      dispatch(
        handleErrorException(
          ex,
          types.FETCH_ACCT_CATEGORY_DATA_LOADING_ERROR,
          defaultError
        )
      );
    } finally {
      dispatch(loading(types.FETCH_ACCT_CATEGORY_DATA_LOADING, false));
    }
  };
};

export const getVendorForCurrentSite = () => {
  return async (dispatch, getState, MPWWebApi) => {
    dispatch(loading(types.FETCH_VENDOR_DATA_LOADING, true));

    try {
      const response = await MPWWebApi.getGeneric('InvVendors');
      dispatch(success(types.SET_VENDOR_DATA, response));
    } catch (ex) {
      const defaultError = {
        Title: TitleEnum.Error,
        Message: 'An error occurred while fetching vendors. Please try again.',
      };
      dispatch(
        handleErrorException(
          ex,
          types.FETCH_VENDOR_DATA_LOADING_ERROR,
          defaultError
        )
      );
    } finally {
      dispatch(loading(types.FETCH_VENDOR_DATA_LOADING, false));
    }
  };
};

export const getStorageLocationForCurrentSite = storageLocationEnum => {
  return async (dispatch, getState, MPWWebApi) => {
    dispatch(loading(types.FETCH_STORAGE_LOCATION_DATA_LOADING, true));
    let url = 'InvGroup/GetStorageLocations';
    if (storageLocationEnum) {
      url += `/${storageLocationEnum}`;
    }
    try {
      const response = await MPWWebApi.getGeneric(url);
      dispatch(success(types.SET_STORAGE_LOCATION_DATA, response));
    } catch (ex) {
      const defaultError = {
        Title: TitleEnum.Error,
        Message:
          'An error occurred while fetching storage location. Please try again.',
      };
      dispatch(
        handleErrorException(
          ex,
          types.FETCH_STORAGE_LOCATION_DATA_LOADING_ERROR,
          defaultError
        )
      );
    } finally {
      dispatch(loading(types.FETCH_STORAGE_LOCATION_DATA_LOADING, false));
    }
  };
};
export const getSiteGroupDataForCurrentSite = () => {
  return async (dispatch, getState, MPWWebApi) => {
    dispatch(loading(types.FETCH_SITE_GROUP_DATA, true));

    try {
      const response = await MPWWebApi.getGeneric(
        `AssignEntities/GetSiteGroups`
      );
      dispatch(
        success(
          types.SET_SITE_GROUP_DATA,
          response.data.Data.Data ? response.data.Data.Data : []
        )
      );
    } catch (err) {
      const defaultError = {
        Title: TitleEnum.Error,
        Message:
          'An error occurred while fetching site group data. Please try again.',
      };
      dispatch(
        handleErrorException(
          err,
          types.FETCH_SITE_GROUP_DATA_ERROR,
          defaultError
        )
      );
    } finally {
      dispatch(loading(types.FETCH_SITE_GROUP_DATA, false));
    }
  };
};
export const clearFilterErrorMsg = () => {
  return {
    type: types.CLEAR_ERROR_MSG,
  };
};



// WEBPACK FOOTER //
// ./src/state/filters/actions.js